import { useEffect } from "react";

function GoogleAnalytics() {
  useEffect(() => {
    // Google Analytics script load karna
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-EYHFC5TBRP";
    script1.async = true;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-EYHFC5TBRP', { send_page_view: false });
    `;
    document.head.appendChild(script2);
  }, []);

  return null; // UI me kuch nahi dikhata
}

export default GoogleAnalytics;
